module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_down.75c20.png";